/**
 * Social class for sharing
 */
export default class Social {
    /**
     * Open new browser window for sharing
     *
     * @param url
     */
    newWindow(url) {
        const left = (window.screen.width - 570) / 2;
        const top = (window.screen.height - 570) / 2;
        const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;
        window.open(url, 'NewWindow', params);
    }
}
